import React, { useState } from 'react';
import styled from 'styled-components';
import { Dialog, Item, Icon } from '@zebra-fed/zds-react-desktop';
import '@zebra-fed/icons/Navigation/index.css';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography'
import firebaseUtil from '../../data/FirebaseUtil'
import '@zebra-fed/icons/Enterprise/index.css';
import config from '../../data/application.properties'
import {useTranslation} from "react-i18next";
var validator = require("email-validator");

const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px;
    padding-top: 0px;
    text-align: center;
`

const StyledTextField = styled(TextField)`
    width: 280px;
    display: flex;
`;

const ResponseMessage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px;
    text-align: center;
`

export default function FogotPasswordModal(props) {
    const [email, setEmail] = useState('')
    const dialogRef = props.modalRef;
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [enableButton, setEnableButton] = useState(false)
    const { t } = useTranslation()

    const [responseMsg, setResponseMsg] = useState({
        msg: '',
        color: 'inherit'
    })

    async function resetPassword() {
        let emailError = false
        if (email.trim() === "" || !validator.validate(email)) {
            emailError = true
            setError(true)
        }

        if (!emailError) {
            setIsLoading(true)
            setError(false)
            setEnableButton(true)
            let response = await firebaseUtil.resetPassword({ email: email },t)
            setEnableButton(!enableButton)
            setIsLoading(false)

            if (response.status) {
                setResponseMsg({ msg: response.msg, color: 'primary' })
                setTimeout(clearForm, 4000)
            } else {
                setResponseMsg({ msg: response.msg, color: 'error' })
                setEnableButton(false)
            }
        }
    }

    function clearForm() {
        setError(false)
        setEnableButton(false)
        setEmail('')
        setResponseMsg({ color: '', msg: '' })
        dialogRef.current.toggleDialog()
    }

    return (
        <>
            <Dialog ref={dialogRef}
                key='dialog2'
                width='580px'
                style={{ cursor: isLoading ? 'wait' : 'default' }}
                items={[
                    <Item
                        type='button'
                        style={{ backgroundColor: '#757575', width: '102px' }}
                        onClick={() => { clearForm() }}
                    >
                        {t ('cancel')}
                    </Item>,
                    <Item
                        type='button'
                        disabled={enableButton}
                        onClick={() => { resetPassword() }}
                    >
                        {t ("resetPassword")}
                    </Item>,
                ]}
                headerStyle={{ display: 'none' }}
                bodyStyle={{ padding: '0px', width: '100%' }}
                cardStyle={{ marginBottom: '80px' }}
            >
                <ModalHeader>
                    {t ('deviceTracker')}
                </ModalHeader>
                <MainContent>
                    <h3 style={{ marginBottom: '8px ' }}>{t("forgotYourPassword")}</h3>
                    <div style={{ width: '100%' }}>
                        {t("passwordResetMsg")}
                    </div>
                    <StyledTextField
                        error={error}
                        label={t('passwordResetEmailInput')}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        autoComplete="email"
                        helperText={error ? t('validation.rules.emailValidation') : null}
                        InputProps={{
                            endAdornment:
                                <Icon
                                    category={'navigation'}
                                    name={'close'}
                                    size={15}
                                    style={{ cursor: 'pointer' }}
                                    color={'#bdbdbd'}
                                    onClick={() => {
                                        setResponseMsg({ msg: '', color: '' })
                                        setEmail('')
                                    }}
                                />
                        }}
                    />
                </MainContent>
                <Typography style={{ margin: 'auto', wordWrap: 'break-word', width: '90%', fontSize: '14px' }} color={responseMsg.color}>{responseMsg.msg}</Typography>
            </Dialog>
        </>
    )
}